import React from 'react';
import { IonPage, IonRouterOutlet } from '@ionic/react';
import { Route, Redirect } from 'react-router-dom';
import ContactLists from './ContactLists';
import Contacts from './Contacts';
import ContactViewForCreation from './ContactViewForCreation';
import ContactViewForReading from './ContactViewForReading';
import ContactViewForUpdating from './ContactViewForUpdating';

const ID_PATH_EXCLUDING_NEW =
  ':contactId(n|ne|n[^e][^/]*|ne[^w][^/]*|new[^/]+|[^n][^/]*)';

const AddressBookRouter: React.FC = () => (
  <IonPage>
    <IonRouterOutlet>
      <Route exact path="/ab/lists" component={ContactLists} />
      <Route exact path="/ab/lists/:listId/contacts" component={Contacts} />
      <Route exact path="/ab/contacts/new" component={ContactViewForCreation} />
      <Route
        exact
        path={`/ab/contacts/${ID_PATH_EXCLUDING_NEW}/edit`}
        component={ContactViewForUpdating}
      />
      <Route
        exact
        path={`/ab/contacts/${ID_PATH_EXCLUDING_NEW}`}
        component={ContactViewForReading}
      />
      <Route
        exact
        path="/ab"
        render={() => <Redirect to="/ab/lists/all/contacts" />}
      />
    </IonRouterOutlet>
  </IonPage>
);

export default AddressBookRouter;
